<template>
  <div class="box">
    <div class="back" @click="back">back</div>
    <div class="pdBox flex">
      <img class="combImg" :src="globalDataUrl + selectList.img" alt="" />
      <div class="mt10">
        <div class="bold color1">{{ selectList.title }}</div>
        <div class="mt5">{{ selectList.desc }}</div>
      </div>
    </div>
    <div
      v-for="(products, index) in selectList.step"
      :key="index"
      @click="clkFlavors(0, index)"
    >
      <div
        class="productItems p-re"
        :class="index == stepIndex ? 'active' : ''"
      >
        <div>{{ products.name }}</div>
        <img
          v-if="products.selectProduct"
          src="@/assets/close.png"
          alt=""
          @click.stop="clearProduct(index)"
          class="closeImg"
        />
      </div>
      <div class="pdBox flex btm p-re">
        <img
          :src="
            products.selectProduct
              ? globalDataUrl + products.selectProduct.image
              : require('@/assets/emptyCake.png')
          "
          alt=""
          class="proImg"
        />
        <div>
          {{ products.selectProduct ? products.selectProduct.name : "" }}
        </div>
      </div>
      <div v-if="products.modifierGroup">
        <div
          @click.stop="clkFlavors(mindex, index)"
          v-for="(mitems, mindex) in products.modifierGroup"
          :key="mitems.id"
          class="flavorsBox"
          :class="
            index == stepIndex && mindex == flavorsIndex ? 'borderBox' : ''
          "
        >
          <div class="flex-between w100">
            <div>{{ mitems.name }}</div>
            <div class="fs12">
              {{ mitems.seNumber ? mitems.seNumber : 0 }}/{{ mitems.max }}
            </div>
          </div>
          <div class="w100 flex-wrap minHbox mt5">
            <div
              class="flex p-re pnameBox"
              v-for="(fitems, findex) in mitems.chooseModifierArr"
              :key="findex"
            >
              <img
                v-if="mitems.min == mitems.max"
                :src="
                  fitems.image
                    ? globalDataUrl + fitems.image
                    : require('@/assets/emptyCake.png')
                "
                alt=""
                class="proImg"
              />
              <div class="fs12 color nameWidthBox">
                {{ fitems.name }}
              </div>
              <div
                v-if="fitems.id"
                class="flavorsClose"
                @click.stop="deleteFlavors(fitems, index, mindex)"
              >
                x
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div v-if="stepProductList&&stepProductList[index]&&stepProductList[index].modifierGroup">
        <div v-for="mitems in stepProductList[index].modifierGroup" :key="mitems.id">
          {{ mitems.name }}
          <div class="flex w100 flex-wrap">
            <div v-for="fitems,index in mitems.max" :key="index">
            <img src="@/assets/emptyCake.png" alt="" class="proImg">
          </div>
          </div>
        </div>
      </div> -->
    </div>
    <div
      class="btn mt15 storeAddBtn"
      :class="checkselectList ? '' : 'disBtn'"
      @click.stop="addToCart"
    >
      Add to Cart
    </div>
  </div>
</template>

<script>
import { log } from "console";
import { mapState, mapMutations } from "vuex";
import Cart from "@/components/Cart/Cart";
export default {
  components: { Cart },
  data() {
    return {
      pList: [],
    };
  },
  computed: {
    ...mapState([
      "selectList",
      "productIndex",
      "productObj",
      "stepIndex",
      "flavorsIndex",
    ]),
    stepProductList() {
      if (
        (this.productObj && JSON.stringify(this.productObj) != "{}") ||
        (JSON.stringify(this.pList[this.stepIndex]) != "{}" && this.productObj)
      ) {
        this.pList[this.stepIndex] = { ...this.productObj };
      }
      // if(this.modifierGroup){
      //   console.log(this.pList,[this.stepIndex])
      // }
      this.CLEAR_PRODUCTOBJ();
      return { ...this.pList };
    },
    checkselectList() {
      let selectList = this.selectList,
        flag = true;

      for (let si = 0; si < selectList.step.length; si++) {
        if (!selectList.step[si].modifierGroup) {
          // console.log(111);
          flag = false;
          break;
        } else {
          for (
            let mi = 0;
            mi < Object.keys(selectList.step[si].modifierGroup).length && flag;
            mi++
          ) {
            // debugger
            if (
              selectList.step[si].modifierGroup[mi].min ==
              selectList.step[si].modifierGroup[mi].max
            ) {
              for (
                let ci = 0;
                ci <
                selectList.step[si].modifierGroup[mi].chooseModifierArr.length;
                ci++
              ) {
                if (
                  JSON.stringify(
                    selectList.step[si].modifierGroup[mi].chooseModifierArr[ci]
                  ) == "{}"
                ) {
                  flag = false;
                  break;
                }
              }
            }
          }
        }
      }
      return flag;
    },
  },
  watch: {
    modifierGroup(newVal, oldVal) {
      this.selectList.step[this.stepIndex].modifierGroup = newVal;
      // this.stepProductList[this.stepIndex].modifierGroup=newVal;
      // console.log(newVal,oldVal);
    },
  },
  props: ["orderstoreid", "categoryid", "cartInfo"],
  created() {
    this.globalDataUrl = this.$root.globalData.url;
    let that = this;
    // console.log(this.orderstoreid,333)
  },
  methods: {
    ...mapMutations([
      "CLEAR_SELECT",
      "CLEAR_PRODUCTOBJ",
      "FLAVORSINDEX",
      "CLEAR_MODIFIERGROUP",
      "EDIT_CHOOSEMODIFIERARR",
    ]),
    back() {
      this.CLEAR_SELECT();
    },
    deleteFlavors(pitem, stepIndex, flavorsIndex) {
      // console.log("deleteFlavors", pitem, stepIndex, flavorsIndex);
      pitem.selectNumber--;
      this.EDIT_CHOOSEMODIFIERARR({
        modifiersObj: pitem,
        type: "reduce",
        stepIndex,
        flavorsIndex,
      });
    },
    clearProduct(stepIndex) {
      this.FLAVORSINDEX({ flavorsIndex: 0, stepIndex });
      this.CLEAR_MODIFIERGROUP();
    },
    clkFlavors(flavorsIndex, stepIndex) {
      // console.log(flavorsIndex,stepIndex);
      this.FLAVORSINDEX({ flavorsIndex:Number(flavorsIndex), stepIndex });
    },
    addToCart() {
      let step = this.selectList.step,
        data,that=this;
      let cartInfo = { ...this.cartInfo };
      let dataAll=cartInfo;
      // console.log("selectList",this.selectList);
      let selectParams={
        combPackageId:this.selectList.id,
        combPackageGroupKey:Math.random().toString().split(".")[1],
        combPackageGroupName:this.selectList.title,
        combPackageQuantity:++this.selectList.combPackageQuantity
      }
      // console.log("selectParams",selectParams);
      step.forEach((ele, index) => {
        // console.log(`output->selectParams`,selectParams)
        data = Cart.methods.checkData(null,null,null,ele.modifierGroup,this.orderstoreid,ele,selectParams,this.globalDataUrl);
        // console.log("ele", data);
        dataAll = Cart.methods.checkSame(data, dataAll,true);
      });
      this.$loading()
      // console.log(`output->dataAll`,dataAll)
      this.$http.Post("mobile/cart", dataAll).then((res) => {
        // console.log(3232323, res);
        if (res.code == 1) {
          that.$emit("cartInfoFn",dataAll)
          that.CLEAR_SELECT();
          setTimeout(() => {
            that.$loading().close()
          }, 500);
        }
      });
    },
    getMenuModi() {
      let that = this;
      this.$loading();
      return new Promise((resolve, reject) => {
        this.$http
          .Get(
            "mobile/menumodi?orderstoreid=" +
              this.orderstoreid +
              "&categoryid=" +
              this.categoryid,
            {}
          )
          .then(function (res) {
            if (res.code == 1) {
              resolve(res);
            } else {
              // console.log(res);
              reject(res);
            }
            that.$loading().close();
          })
          .catch(function (err) {
            that.$loading().close();
            reject(err);
          });
      });
    },
  },
};
</script>

<style scoped>
.box {
  width: 300px;
  min-height: 500px;
  border: 1px solid #ccc;
  border-radius: 10px;
  margin-right: 30px;
  margin-left: -20px;
  font-size: 12px;
  position: relative;
}
.closeImg {
  position: absolute;
  right: 5px;
  top: 10px;
  width: 15px;
  height: 15px;
  padding: 5px;
  box-sizing: content-box;
  cursor: pointer;
}
.back {
  position: absolute;
  top: -30px;
}
.combImg {
  width: 80px;
  height: 80px;
}
.pdBox {
  padding: 8px;
}
.productItems {
  color: #fff;
  background: rgb(220, 220, 220);
  padding: 15px 10px;
  display: flex;
  justify-content: space-between;
}
.productItems.active {
  background: rgb(216, 90, 162);
}
.proImg {
  width: 50px;
  height: 50px;
}
.btm {
  border-bottom: 1px solid #ccc;
}
.flavorsBox {
  border: 1px solid transparent;
  border-radius: 5px;
  margin: 5px;
  padding: 10px;
}
.borderBox {
  border: 1px solid rgb(216, 90, 162);
}
.minHbox {
  min-height: 50px;
}
.nameWidthBox {
  width: calc(100% - 50px - 10px - 5%);
}
.flavorsClose {
  content: "x";
  position: absolute;
  top: -5px;
  right: 0;
  padding: 5px;
  box-sizing: content-box;
  opacity: 0;
  transition: 0.25s;
  cursor: pointer;
}
.pnameBox:hover .flavorsClose {
  opacity: 1;
}
.disBtn {
  pointer-events: none;
  opacity: 0.3;
}
.storeAddBtn{
  width: 90%;
  margin: 15px auto;
  
}
</style>